export const APIURL = process.env.REACT_APP_APIURL;
export const SITEURL = process.env.REACT_APP_SITEURL;
export const SCORMURL = process.env.REACT_APP_SCORMURL;
export const ENV_NAME = "akademi";

export const LOGIN_FORMS = {
  SSO_CHECK: 0,
  LOGIN: 1,
  FORGOT_PASSWORD: 2,
  NEW_PASSWORD: 3,
  PRELOGIN : 4,
  PRELOGINEMAIL : 5
};

export const LANGUAGES = {
  Turkish: "tr-TR",
  English: "en-US",
  Arabic: "ar-AE",
  French: "fr-FR",
  German: "de-DE",
  Russian: "ru-RU",
  Spanish: "es-ES",
  Croatian: "hr-HR",
  Italian: "it-IT",
};

export const LANGUAGE_CODES = {
  Turkish: 1055,
  English: 1033,
  Arabic: 14337,
  French: 1036,
  German: 1031,
  Russian: 1049,
  Spanish: 1034,
  Croatian: 1050,
  Italian: 1040,
};

export const AADLogin = {
  IsActive: true,
  Tenant: process.env.REACT_APP_AAD_TENANTID,
  SignOutRedirectUri: SITEURL + "/logout",
  ClientId: process.env.REACT_APP_AAD_CLIENTID,
  SignInRedirectUri: SITEURL + "/sso",
};

export const GoogleReCaptcha = {
  SiteKey: process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY,
};
